import { render, staticRenderFns } from "./Wizard-Thanks.vue?vue&type=template&id=2243485f&scoped=true"
import script from "./Wizard-Thanks.vue?vue&type=script&lang=js"
export * from "./Wizard-Thanks.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Thanks.vue?vue&type=style&index=0&id=2243485f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243485f",
  null
  
)

export default component.exports